import { TapError } from '@iotize/tap';
import { TapRequestFrame } from '@iotize/tap/client/api';

export class TapScramError extends TapError {
  constructor(
    code: TapError.Code,
    message: string,
    public request: TapRequestFrame,
  ) {
    super(code, message, undefined);
  }

  static scramNotStartedYet(failedRequest: TapRequestFrame) {
    return new TapScramError(
      TapError.Code.ScramNotStartedYet,
      `SCRAM session has not been initialized yet. You cannot use secure communication.`,
      failedRequest,
    );
  }

  static invalidScramKey(failedRequest: TapRequestFrame) {
    return new TapScramError(
      TapError.Code.InvalidScramKey,
      `SCRAM session key is not valid.`,
      failedRequest,
    );
  }
}
